import { Inline, LinkButton, Stack, Text, vars } from '@etg/wings';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import isFunction from 'lodash/isFunction';
import { CaretDown } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import ExpandableContent from '../expandable_content/ExpandableContent';
import AvailabilityStatus from './AvailabilityStatus';
import { airportRow, listWrapper, title } from './styles';
import AvailabilityAccordion from './AvailabilityAccordion';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const iconStyles = showMore => css`
  color: ${vars.colors.links.default};
  flex-shrink: 0;
  transform: rotateX(${showMore ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
`;
const listItemStyles = css`
  display: flex;
  grid-area: 1 / 1 / 2 / 3;
  justify-content: space-between;
`;
const AirportList = props => {
  const {
    accordionData,
    availabilityList,
    hideTitle,
    isDrawerOpen,
    isSelected,
    listTitle,
    openDrawer,
    productData,
    testId,
    toggleAccordion
  } = props;
  const {
    amenities,
    addedStatus,
    availableStatus,
    statusTooltip,
    unavailableStatus,
    seeAll,
    condition,
    location,
    openingFrom,
    openingTo,
    openingTitle,
    terminal
  } = productData.extraProps;
  const shouldExpandAccordion = airport => {
    return airport.boundIndex === (accordionData === null || accordionData === void 0 ? void 0 : accordionData.boundIndex) && airport.segmentIndex === (accordionData === null || accordionData === void 0 ? void 0 : accordionData.segmentIndex);
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (availabilityList === null || availabilityList === void 0 ? void 0 : availabilityList.length) > 0 && /*#__PURE__*/_jsxs("div", {
      "data-testid": testId,
      children: [!hideTitle && listTitle && /*#__PURE__*/_jsx(Text, {
        className: title,
        id: `list-title-${listTitle}`,
        children: listTitle
      }), /*#__PURE__*/_jsx("div", {
        "aria-labelledby": `list-title-${listTitle}`,
        className: listWrapper,
        role: "list",
        children: availabilityList.map((airport, index) => {
          var _airport$loungeInfo, _airport$loungeInfo2, _airport$loungeInfo$l, _airport$loungeInfo3;
          return /*#__PURE__*/_jsxs("li", {
            className: airportRow,
            children: [/*#__PURE__*/_jsxs(Inline, {
              className: listItemStyles,
              children: [/*#__PURE__*/_jsx(Text, {
                className: "airportName",
                children: airport.departureAirport
              }), /*#__PURE__*/_jsx(AvailabilityStatus, {
                addedStatus: addedStatus,
                availableStatus: availableStatus,
                departureAirport: airport.departureAirport,
                isAirportAvailable: airport.available,
                isCardSelected: isSelected,
                statusTooltip: statusTooltip,
                unavailableStatus: unavailableStatus
              })]
            }), isFunction(openDrawer) && airport.available && airport.loungeInfo && /*#__PURE__*/_jsxs("div", {
              className: "loungeName",
              children: [/*#__PURE__*/_jsx(Text, {
                children: (_airport$loungeInfo = airport.loungeInfo) === null || _airport$loungeInfo === void 0 ? void 0 : _airport$loungeInfo.loungeName
              }), /*#__PURE__*/_jsx(LinkButton, {
                "aria-controls": "lounge-info-drawer",
                "aria-expanded": isDrawerOpen,
                "aria-haspopup": "dialog",
                "data-testid": "loungeDrawerLink",
                onClick: () => openDrawer(airport),
                children: seeAll
              })]
            }), isFunction(toggleAccordion) && airport.available && airport.loungeInfo && /*#__PURE__*/_jsxs(Stack, {
              className: "loungeAccordion",
              children: [/*#__PURE__*/_jsxs(Inline, {
                spacing: 8,
                children: [/*#__PURE__*/_jsx(Text, {
                  children: (_airport$loungeInfo2 = airport.loungeInfo) === null || _airport$loungeInfo2 === void 0 ? void 0 : _airport$loungeInfo2.loungeName
                }), /*#__PURE__*/_jsx(LinkButton, {
                  "aria-controls": "availability-accordion-info-content",
                  "aria-expanded": shouldExpandAccordion(airport),
                  "aria-label": `${seeAll} ${airport.departureAirport} ${(_airport$loungeInfo$l = (_airport$loungeInfo3 = airport.loungeInfo) === null || _airport$loungeInfo3 === void 0 ? void 0 : _airport$loungeInfo3.loungeName) !== null && _airport$loungeInfo$l !== void 0 ? _airport$loungeInfo$l : ''}`,
                  onClick: () => toggleAccordion(airport),
                  children: /*#__PURE__*/_jsxs(Inline, {
                    noWrap: true,
                    spacing: 4,
                    children: [seeAll, /*#__PURE__*/_jsx(CaretDown, {
                      "aria-hidden": true,
                      className: iconStyles(shouldExpandAccordion(airport)),
                      size: 20,
                      weight: "light"
                    })]
                  })
                })]
              }), /*#__PURE__*/_jsx(ExpandableContent, {
                isExpanded: shouldExpandAccordion(airport),
                children: /*#__PURE__*/_jsx(AvailabilityAccordion, {
                  amenities: amenities,
                  condition: condition,
                  location: location,
                  loungeInfo: airport.loungeInfo,
                  openingFrom: openingFrom,
                  openingTitle: openingTitle,
                  openingTo: openingTo,
                  terminal: terminal
                })
              })]
            })]
          }, index);
        })
      })]
    })
  });
};
export default AirportList;
//# sourceMappingURL=AirportList.js.map